import React from "react";

const SpinnerAnimation = () => {
  return (
    <>
      <div className="text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </>
  );
};

export default SpinnerAnimation;
